<template>
  <div class="page-title">
    <div class="page-title__container">
      <h1 class="page-title__title">
        <slot name="title" />
      </h1>
      <p v-if="$slots.subtitle" class="page-title__subtitle">
        <slot name="subtitle" />
      </p>
    </div>
    <div v-if="$slots.button" class="page-title__button">
      <slot name="button" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.page-title_container {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  max-width: 53.7rem;
}

.page-title {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.375rem 0.5rem;

  @include tablet {
    padding: 0.5rem 1rem;
  }

  &__title {
    @include header-3;
    color: $color-text-default;
  }

  &__subtitle {
    @include body;
    color: $color-text-default;

    :deep(a) {
      @include link;
    }
  }
}
</style>
